import { CredentialEntity, DropboxCredentialToCredentialEntityMapper } from '@uploadcam/common';
import { ExchangeAuthCodeInteractor } from '../../auth/domain/interactors/exchange-auth-code.interactor';

export class ExchangeDropboxAuthCodeInteractor implements ExchangeAuthCodeInteractor {
  constructor(
    private readonly clientId: string,
    private readonly redirectUri: string,
  ) {}

  public async execute(code: string, verifier: string): Promise<CredentialEntity> {
    const mapper = new DropboxCredentialToCredentialEntityMapper(Date.now());
    const res = await fetch('https://api.dropbox.com/oauth2/token', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: new URLSearchParams({
        grant_type: 'authorization_code',
        client_id: this.clientId,
        redirect_uri: this.redirectUri,
        code,
        code_verifier: verifier,
      }),
    });

    return mapper.map(await res.json());
  }
}
